import { globalColors } from "./colors";
import GeoLocationIcon from "../assets/Geolocation.svg";

const SingleSelectIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4933 4.16003C12.3133 4.0267 12.0933 3.97336 11.8733 4.0067C11.6533 4.04003 11.46 4.16003 11.3267 4.33336L7.17333 9.9667L4.52 7.84003C4.28667 7.6467 3.96667 7.59336 3.68667 7.70003C3.40667 7.8067 3.2 8.06003 3.16 8.36003C3.12 8.66003 3.24 8.96003 3.48 9.14003L6.81333 11.8067C6.96 11.9267 7.14667 11.9867 7.33333 11.9867C7.6 11.9867 7.84667 11.8667 8.00667 11.6534L12.6733 5.32003C12.8067 5.14003 12.86 4.92003 12.8267 4.70003C12.7933 4.48003 12.6733 4.2867 12.4933 4.15336V4.16003Z"
        fill={globalColors.primary}
      />
      <path
        d="M14.6667 14.5C14.6667 14.5934 14.5933 14.6667 14.5 14.6667H1.5C1.45333 14.6667 1.41333 14.6467 1.38 14.62C1.34667 14.5867 1.33333 14.5467 1.33333 14.5V1.50003C1.33333 1.45336 1.35333 1.41336 1.38 1.38003C1.41333 1.3467 1.45333 1.33336 1.5 1.33336H14.5C14.5933 1.33336 14.6667 1.4067 14.6667 1.50003V14.5ZM14.6667 3.05176e-05H1.33333C0.6 3.05176e-05 0 0.600031 0 1.33336V14.6667C0 15.4067 0.6 16 1.33333 16H14.6667C15.4 16 16 15.4067 16 14.6667V1.33336C16 0.600031 15.4 3.05176e-05 14.6667 3.05176e-05Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const MultiSelectIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12.3334C3.81333 12.3334 3.66667 12.1867 3.66667 12V1.6667C3.66667 1.48003 3.81333 1.33336 4 1.33336H14.3333C14.52 1.33336 14.6667 1.48003 14.6667 1.6667V12C14.6667 12.1867 14.52 12.3334 14.3333 12.3334H4ZM14.6667 3.05176e-05H3.66667C2.93333 3.05176e-05 2.33333 0.600031 2.33333 1.33336V12.3334C2.33333 13.0667 2.93333 13.6667 3.66667 13.6667H14.6667C15.4 13.6667 16 13.0734 16 12.3334V1.33336C16 0.600031 15.4 3.05176e-05 14.6667 3.05176e-05Z"
        fill={globalColors.primary}
      />
      <path
        d="M13 14.6667H1.66667C1.48 14.6667 1.33333 14.52 1.33333 14.3334V3.00003C1.33333 2.63336 1.03333 2.33336 0.666667 2.33336C0.3 2.33336 0 2.63336 0 3.00003V14.6667C0 15.4 0.6 16 1.33333 16H13C13.3667 16 13.6667 15.7 13.6667 15.3334C13.6667 14.9667 13.3667 14.6667 13 14.6667Z"
        fill={globalColors.primary}
      />
      <path
        d="M12.1 4.0667C11.7467 3.80003 11.2467 3.87336 10.98 4.2267L8.58667 7.41336L7.27333 6.10003C6.96 5.7867 6.45333 5.7867 6.14 6.10003C5.82667 6.41336 5.82667 6.92003 6.14 7.23336L7.7 8.79336C7.96667 9.05336 8.33333 9.1867 8.70667 9.16003C9.08 9.13336 9.42 8.95336 9.64667 8.65336L12.2533 5.18003C12.52 4.8267 12.4467 4.3267 12.0933 4.06003L12.1 4.0667Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const InputIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 14.6667H1.5C1.40667 14.6667 1.33333 14.5934 1.33333 14.5V1.50003C1.33333 1.4067 1.40667 1.33336 1.5 1.33336H14.5C14.5933 1.33336 14.6667 1.4067 14.6667 1.50003V14.5C14.6667 14.5934 14.5933 14.6667 14.5 14.6667ZM14.6667 3.05176e-05H1.33333C0.6 3.05176e-05 0 0.600031 0 1.33336V14.6667C0 15.4 0.6 16 1.33333 16H14.6667C15.4 16 16 15.4 16 14.6667V1.33336C16 0.600031 15.4 3.05176e-05 14.6667 3.05176e-05Z"
        fill={globalColors.primary}
      />
      <path
        d="M11.3333 7.1667H4.66667C4.39052 7.1667 4.16667 7.39055 4.16667 7.6667V8.33336C4.16667 8.60951 4.39052 8.83336 4.66667 8.83336H11.3333C11.6095 8.83336 11.8333 8.60951 11.8333 8.33336V7.6667C11.8333 7.39055 11.6095 7.1667 11.3333 7.1667Z"
        fill={globalColors.primary}
      />
      <path
        d="M11.3333 4.1667H4.66667C4.39052 4.1667 4.16667 4.39055 4.16667 4.6667V5.33336C4.16667 5.60951 4.39052 5.83336 4.66667 5.83336H11.3333C11.6095 5.83336 11.8333 5.60951 11.8333 5.33336V4.6667C11.8333 4.39055 11.6095 4.1667 11.3333 4.1667Z"
        fill={globalColors.primary}
      />
      <path
        d="M8 10.1667H4.66667C4.39052 10.1667 4.16667 10.3906 4.16667 10.6667V11.3334C4.16667 11.6095 4.39052 11.8334 4.66667 11.8334H8C8.27614 11.8334 8.5 11.6095 8.5 11.3334V10.6667C8.5 10.3906 8.27614 10.1667 8 10.1667Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const RichTextIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M612.6 83.9H948c6.2 0 11.3 5 11.3 11.3V139c0 6.2-5 11.3-11.3 11.3H612.6c-6.2 0-11.3-5-11.3-11.3V95.2c0-6.3 5-11.3 11.3-11.3zM601.3 336.4v-43.9c0-6.2 5-11.3 11.3-11.3H948c6.2 0 11.3 5 11.3 11.3v43.9c0 6.2-5 11.3-11.3 11.3H612.6c-6.3 0-11.3-5.1-11.3-11.3zM601.3 533.8v-43.9c0-6.2 5-11.3 11.3-11.3H948c6.2 0 11.3 5 11.3 11.3v43.9c0 6.2-5 11.3-11.3 11.3H612.6c-6.3 0-11.3-5.1-11.3-11.3zM64 731.2v-43.9c0-6.2 5-11.3 11.3-11.3H948c6.2 0 11.3 5 11.3 11.3v43.9c0 6.2-5 11.3-11.3 11.3H75.3c-6.3 0-11.3-5.1-11.3-11.3zM64 928.6v-43.9c0-6.2 5-11.3 11.3-11.3H948c6.2 0 11.3 5 11.3 11.3v43.9c0 6.2-5 11.3-11.3 11.3H75.3c-6.3 0-11.3-5-11.3-11.3zM64.2 155.3V94.6c0-6.2 5-11.3 11.3-11.3h425c6.2 0 11.3 5 11.3 11.3v61.1c0 6.2-5 11.3-11.3 11.3l-425-0.3c-6.3-0.1-11.3-5.1-11.3-11.4z"
        fill={globalColors.primary}
      />
      <path
        d="M243.2 165h89.5v427.5c0 11.3-9.2 20.5-20.5 20.5h-48.6c-11.3 0-20.5-9.2-20.5-20.5V165z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const NameAndSurnameIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6933 3.05176e-05H1.30667C0.586667 3.05176e-05 0 0.586453 0 1.30615V14.6939C0 15.4136 0.586667 16 1.30667 16H12C12 16 12.0067 16 12.0133 16H14.6933C15.4133 16 16 15.4203 16 14.7006V1.30615C16 0.586453 15.4133 3.05176e-05 14.6933 3.05176e-05ZM14.36 14.6606H10.8667C10.8667 14.6606 10.8467 14.6606 10.84 14.6606L1.66667 14.6806C1.48 14.6806 1.33333 14.534 1.33333 14.3474V10.8488L1.30667 1.666C1.30667 1.47941 1.45333 1.33281 1.64 1.33281H13.1C13.1 1.33281 13.16 1.31948 13.1867 1.31282H14.3333C14.52 1.30615 14.6667 1.45276 14.6667 1.63935V5.13123C14.6667 5.13123 14.6667 5.13123 14.6667 5.13789L14.6933 14.3274C14.6933 14.514 14.5467 14.6606 14.36 14.6606Z"
        fill={globalColors.primary}
      />
      <path
        d="M8.08667 8.32989C6.01333 8.28325 4.24667 9.8226 4.00667 11.8817C3.98667 12.0817 4.04667 12.2749 4.18 12.4282C4.31333 12.5748 4.5 12.6614 4.7 12.6614H11.4333C11.5867 12.6614 11.74 12.5948 11.84 12.4815C11.9467 12.3682 12.0067 12.2149 11.9933 12.0617C11.8467 9.99587 10.1533 8.37654 8.08 8.32989H8.08667Z"
        fill={globalColors.primary}
      />
      <path
        d="M7.99333 7.6635C9.282 7.6635 10.3267 6.61927 10.3267 5.33114C10.3267 4.04301 9.282 2.99878 7.99333 2.99878C6.70467 2.99878 5.66 4.04301 5.66 5.33114C5.66 6.61927 6.70467 7.6635 7.99333 7.6635Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const AddressIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C5.24267 0 3 2.24267 3 5C3 8.5 8 16 8 16C8 16 13 8.5 13 5C13 2.24267 10.7573 0 8 0ZM8 6.66667C7.08 6.66667 6.33333 5.92 6.33333 5C6.33333 4.08 7.08 3.33333 8 3.33333C8.92 3.33333 9.66667 4.08 9.66667 5C9.66667 5.92 8.92 6.66667 8 6.66667Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const DomainIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66389 13.4004C1.47754 13.4004 1.33111 13.253 1.33111 13.0654V4.02013C1.33111 3.83923 1.47754 3.68512 1.66389 3.68512H14.3095C14.4958 3.68512 14.6423 3.83923 14.6423 4.02013V10.258L15.9734 10.8677V1.34006C15.9734 0.603046 15.381 3.05176e-05 14.6423 3.05176e-05H1.33111C0.599002 3.05176e-05 0 0.603046 0 1.34006V13.4004C0 14.1441 0.599002 14.7404 1.33111 14.7404H10.5491L9.99002 13.4004H1.66389ZM6.65557 1.05866C7.02163 1.05866 7.32113 1.36016 7.32113 1.72867C7.32113 2.09718 7.02163 2.39869 6.65557 2.39869C6.28952 2.39869 5.99002 2.10388 5.99002 1.72867C5.99002 1.35346 6.28952 1.05866 6.65557 1.05866ZM4.32612 1.05866C4.69218 1.05866 4.99168 1.36016 4.99168 1.72867C4.99168 2.09718 4.69218 2.39869 4.32612 2.39869C3.96007 2.39869 3.66057 2.10388 3.66057 1.72867C3.66057 1.35346 3.96007 1.05866 4.32612 1.05866ZM1.99667 1.05866C2.36273 1.05866 2.66223 1.36016 2.66223 1.72867C2.66223 2.09718 2.36273 2.39869 1.99667 2.39869C1.63062 2.39869 1.33111 2.10388 1.33111 1.72867C1.33111 1.35346 1.63062 1.05866 1.99667 1.05866Z"
        fill={globalColors.primary}
      />
      <path
        d="M4.42596 7.35011C4.37271 6.6667 4.33943 6.27139 4.32612 6.16418H3.36106C3.2213 7.18261 3.13478 8.00673 3.1015 8.63655L3.00832 7.42382L2.90849 6.16418H2.00333L2.42263 9.76888H3.57404C3.71381 8.81075 3.80033 8.18093 3.83361 7.87943C3.92013 8.58295 4.01331 9.21276 4.1198 9.76888H5.27787L5.69052 6.16418H4.79201C4.67221 7.00171 4.58569 7.85263 4.53245 8.72365L4.42596 7.35011Z"
        fill={globalColors.primary}
      />
      <path
        d="M8.56572 7.35011C8.51248 6.6667 8.4792 6.27139 8.46589 6.16418H7.49418C7.36106 7.18261 7.27454 8.00673 7.24126 8.63655L7.14809 7.42382L7.04825 6.16418H6.14309L6.5624 9.76888H7.71381C7.84692 8.81075 7.93344 8.18093 7.97338 7.87943C8.05324 8.58295 8.14642 9.21276 8.25291 9.76888H9.15807C9.23128 9.59467 9.34443 9.42717 9.47088 9.28646L9.83028 6.16418H8.92513C8.80532 7.00171 8.7188 7.85263 8.66556 8.72365L8.56572 7.35011Z"
        fill={globalColors.primary}
      />
      <path
        d="M12.7055 7.35011C12.6456 6.6667 12.6123 6.27139 12.599 6.16418H11.6339C11.5008 7.18261 11.4143 8.00673 11.381 8.63655L11.2812 7.42382L11.1814 6.16418H10.2829L10.5757 8.71025C10.6556 8.69685 10.7354 8.69015 10.8153 8.69015C11.0416 8.69015 11.2679 8.73705 11.4809 8.81745L11.5474 8.84425L11.9601 9.03186C12.0333 8.48244 12.0865 8.09383 12.1131 7.87943C12.1664 8.34844 12.2263 8.77725 12.2862 9.17926L13.5574 9.76217L13.97 6.16418H13.0649C12.9451 7.00171 12.8586 7.85263 12.8053 8.72365L12.7055 7.35011Z"
        fill={globalColors.primary}
      />
      <path
        d="M15.9867 12.5427C15.9867 12.5427 15.98 12.5159 15.9734 12.5025C15.9534 12.4221 15.9068 12.3551 15.8469 12.3015C15.8136 12.268 15.7804 12.2479 15.7404 12.2278L14.6423 11.7253L10.995 10.0637C10.9418 10.0436 10.8752 10.0302 10.8153 10.0302C10.6822 10.0302 10.5491 10.0838 10.4559 10.191C10.3095 10.3384 10.2629 10.5595 10.3361 10.7605L11.4343 13.4004L11.9933 14.7404L12.3993 15.7253C12.4725 15.8995 12.6323 16 12.8053 16C12.8386 16 12.8719 16 12.9052 15.9866C13.0915 15.9464 13.2446 15.799 13.3045 15.6047L13.5507 14.7404L13.817 13.8225C13.8303 13.7823 13.8636 13.7488 13.9035 13.7354L15.6206 13.1726C15.6606 13.1592 15.7072 13.1391 15.7404 13.1123C15.7737 13.0922 15.807 13.0654 15.8336 13.0386C15.8536 13.0185 15.8735 12.9984 15.8869 12.9716C15.9002 12.9582 15.9068 12.9448 15.9135 12.9314C15.9334 12.8979 15.9534 12.8644 15.9667 12.8242C15.9667 12.8175 15.9734 12.8175 15.9734 12.8108C15.9867 12.7572 16 12.7035 16 12.6499C16 12.6097 15.9933 12.5762 15.9867 12.5427Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const EmailIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 14.6667H1.5C1.40667 14.6667 1.33333 14.5933 1.33333 14.5V1.5C1.33333 1.40667 1.40667 1.33333 1.5 1.33333H14.5C14.5933 1.33333 14.6667 1.40667 14.6667 1.5V14.5C14.6667 14.5933 14.5933 14.6667 14.5 14.6667ZM14.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V14.6667C0 15.4 0.6 16 1.33333 16H14.6667C15.4 16 16 15.4 16 14.6667V1.33333C16 0.6 15.4 0 14.6667 0Z"
        fill={globalColors.primary}
      />
      <path
        d="M8 9.28C7.31333 9.26 6.77333 8.67333 6.78667 7.97333C6.8 7.27333 7.36667 6.71333 8.05333 6.72C8.74 6.72667 9.29333 7.3 9.29333 8C9.28 8.72 8.7 9.29333 7.99333 9.28H8ZM8 2.66667C5.08667 2.64 2.7 5.02667 2.66667 8C2.7 10.9733 5.08667 13.36 8 13.3333C9.07333 13.3333 10.12 13.0133 11.0067 12.4067C11.1733 12.2933 11.2733 12.0933 11.26 11.8867C11.2467 11.68 11.1267 11.4933 10.9467 11.4067C10.7667 11.3133 10.5467 11.3333 10.38 11.4467C9.68 11.9267 8.84667 12.18 8 12.18C5.71333 12.2067 3.83333 10.34 3.8 8.00667C3.83333 5.67333 5.71333 3.80667 8 3.83333C10.2867 3.80667 12.1667 5.67333 12.2 8.00667V8.42C12.1867 8.90667 11.7933 9.29333 11.32 9.29333C10.8467 9.29333 10.4533 8.90667 10.44 8.42V8.00667C10.46 7 9.87333 6.08 8.96667 5.68C8.06 5.28 7.00667 5.48667 6.3 6.19333C5.59333 6.9 5.38 7.97333 5.75333 8.90667C6.12667 9.84 7.02 10.4467 8.00667 10.4467C8.66667 10.4467 9.3 10.1733 9.76 9.68667C10.2933 10.36 11.1867 10.6133 11.9867 10.3333C12.7867 10.0533 13.3267 9.28667 13.34 8.42V8.00667C13.3067 5.03333 10.92 2.64667 8.00667 2.67333L8 2.66667Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};
const GeolocationIcon = () => {
  return (
    <img src={GeoLocationIcon} alt="Geolocation" />

  );
};

const PhoneIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 13.4533C8 13.8533 7.67333 14.18 7.27333 14.18H2.18C1.78 14.18 1.45333 13.8533 1.45333 13.4533V2.54C1.45333 2.14 1.78 1.81333 2.18 1.81333H5.63333C5.90667 1.33333 6.24667 0.893333 6.63333 0.506667C6.81333 0.326667 7.00667 0.16 7.20667 0H1.82C0.813333 0 0 0.813333 0 1.81333V14.18C0 14.66 0.193333 15.1267 0.533333 15.4667C0.873333 15.8067 1.33333 16 1.82 16H7.63333C8.12 16 8.58 15.8067 8.92 15.4667C9.26 15.1267 9.45333 14.66 9.45333 14.18V10.9933C8.94 10.86 8.45333 10.66 8 10.4V13.4533Z"
        fill={globalColors.primary}
      />
      <path
        d="M3.58 12.7933C3.58 13.2067 3.91333 13.5467 4.33333 13.5467C4.75333 13.5467 5.08667 13.2133 5.08667 12.7933C5.08667 12.3733 4.75333 12.04 4.33333 12.04C3.91333 12.04 3.58 12.3733 3.58 12.7933Z"
        fill={globalColors.primary}
      />
      <path
        d="M11.06 0C8.33333 0 6.12667 2.20667 6.12667 4.93333C6.12667 6.5 6.86 7.9 8 8.80667C8.42667 9.14667 8.92 9.42 9.45333 9.6C9.95333 9.78 10.5 9.87333 11.06 9.87333C13.7867 9.87333 16 7.66 16 4.93333C16 2.20667 13.7867 0 11.06 0ZM13.6267 7.56667C13.6 7.69333 13.4933 7.77333 13.3733 7.77333C10.5267 7.77333 8.22 5.46667 8.22 2.62667C8.22 2.5 8.30667 2.39333 8.42667 2.36667L9.58 2.1C9.70667 2.07333 9.83333 2.14 9.88667 2.26L10.42 3.5C10.4667 3.60667 10.4333 3.73333 10.3467 3.81333L9.67333 4.36C10.08 5.22667 10.7867 5.92667 11.64 6.32667L12.1867 5.65333C12.26 5.56 12.3933 5.53333 12.5 5.58L13.74 6.11333C13.86 6.16 13.9267 6.29333 13.8933 6.41333L13.6267 7.56667Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const MultiInputIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 14C14.6667 14.3667 14.3667 14.6667 14 14.6667H2C1.63333 14.6667 1.33333 14.3667 1.33333 14V2C1.33333 1.63333 1.63333 1.33333 2 1.33333H14C14.3667 1.33333 14.6667 1.63333 14.6667 2V14ZM14 0H2C0.893333 0 0 0.893333 0 2V14C0 15.1067 0.893333 16 2 16H14C15.1067 16 16 15.1067 16 14V2C16 0.893333 15.1067 0 14 0Z"
        fill={globalColors.primary}
      />
      <path
        d="M7.5 3C7.13333 2.72667 6.60667 2.8 6.33333 3.16667L4.91333 5.06667L4.59333 4.74667C4.26667 4.44667 3.76 4.46 3.44667 4.77333C3.13333 5.08667 3.12 5.59333 3.41333 5.92L4.41333 6.92C4.58667 7.08667 4.82 7.17333 5.06 7.16C5.3 7.14 5.52 7.02667 5.66667 6.83333L7.66667 4.16667C7.94 3.8 7.86667 3.27333 7.5 3Z"
        fill={globalColors.primary}
      />
      <path
        d="M7.5 9C7.13333 8.72667 6.60667 8.8 6.33333 9.16667L4.91333 11.0667L4.59333 10.7467C4.38667 10.5267 4.07333 10.44 3.78 10.52C3.48667 10.6 3.26 10.8267 3.18667 11.1133C3.11333 11.4067 3.2 11.7133 3.41333 11.9267L4.41333 12.9267C4.58667 13.0933 4.82 13.18 5.06 13.16C5.3 13.14 5.52 13.02 5.66667 12.8333L7.66667 10.1667C7.94 9.8 7.86667 9.27333 7.5 9Z"
        fill={globalColors.primary}
      />
      <path
        d="M12.3333 5.16667H9.33333C8.87333 5.16667 8.5 5.54 8.5 6C8.5 6.46 8.87333 6.83333 9.33333 6.83333H12.3333C12.7933 6.83333 13.1667 6.46 13.1667 6C13.1667 5.54 12.7933 5.16667 12.3333 5.16667Z"
        fill={globalColors.primary}
      />
      <path
        d="M12.3333 10.5H9.33333C8.87333 10.5 8.5 10.8733 8.5 11.3333C8.5 11.7933 8.87333 12.1667 9.33333 12.1667H12.3333C12.7933 12.1667 13.1667 11.7933 13.1667 11.3333C13.1667 10.8733 12.7933 10.5 12.3333 10.5Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const DropDownIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 14.6667H1.5C1.40667 14.6667 1.33333 14.5933 1.33333 14.5V1.5C1.33333 1.40667 1.40667 1.33333 1.5 1.33333H14.5C14.5933 1.33333 14.6667 1.40667 14.6667 1.5V14.5C14.6667 14.5933 14.5933 14.6667 14.5 14.6667ZM14.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V14.6667C0 15.4 0.6 16 1.33333 16H14.6667C15.4 16 16 15.4 16 14.6667V1.33333C16 0.6 15.4 0 14.6667 0Z"
        fill={globalColors.primary}
      />
      <path
        d="M11.04 4.56667H4.96C3.87333 4.56667 3.24 5.8 3.88 6.68L6.92 10.8867C7.45333 11.62 8.54667 11.62 9.08 10.8867L12.12 6.68C12.76 5.8 12.1267 4.56667 11.04 4.56667Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const HtmlIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6667 14C14.6667 14.3667 14.3667 14.6667 14 14.6667H2C1.63333 14.6667 1.33333 14.3667 1.33333 14V3.5C1.33333 3.40667 1.40667 3.33333 1.5 3.33333H14.5C14.5933 3.33333 14.6667 3.40667 14.6667 3.5V14ZM1.72667 1.39333C1.83333 1.15333 2.07333 1 2.33333 1C2.56667 1 2.78 1.12667 2.9 1.33333C2.96667 1.43333 3 1.54667 3 1.66667C3 1.78667 2.96 1.9 2.9 2C2.78667 2.20667 2.57333 2.33333 2.33333 2.33333C2.09333 2.33333 1.88 2.20667 1.76667 2C1.7 1.9 1.66667 1.78667 1.66667 1.66667C1.66667 1.57333 1.68667 1.48 1.72667 1.39333ZM4.1 1.33333C4.21333 1.12667 4.42667 1 4.66667 1C4.90667 1 5.12 1.12667 5.23333 1.33333C5.3 1.43333 5.33333 1.54667 5.33333 1.66667C5.33333 1.78667 5.29333 1.9 5.23333 2C5.12 2.20667 4.90667 2.33333 4.66667 2.33333C4.42667 2.33333 4.21333 2.20667 4.1 2C4.03333 1.9 4 1.78667 4 1.66667C4 1.54667 4.04 1.43333 4.1 1.33333ZM6.43333 1.33333C6.54667 1.12667 6.76 1 7 1C7.24 1 7.45333 1.12667 7.56667 1.33333C7.63333 1.43333 7.66667 1.54667 7.66667 1.66667C7.66667 1.78667 7.62667 1.9 7.56667 2C7.45333 2.20667 7.24 2.33333 7 2.33333C6.76 2.33333 6.54667 2.20667 6.43333 2C6.36667 1.9 6.33333 1.78667 6.33333 1.66667C6.33333 1.54667 6.37333 1.43333 6.43333 1.33333ZM16 2C16 0.893333 15.1067 0 14 0H2C0.893333 0 0 0.893333 0 2V14C0 15.1067 0.893333 16 2 16H14C15.1067 16 16 15.1067 16 14V2Z"
        fill={globalColors.primary}
      />
      <path
        d="M10.5 10.8267C10.2267 11.1533 10.2733 11.6467 10.6 11.92C10.9267 12.1933 11.4133 12.1467 11.6933 11.82L13.6267 9.5C13.8667 9.21333 13.8667 8.79333 13.6267 8.50667L11.6933 6.18667C11.42 5.86 10.9333 5.81333 10.6 6.08667C10.2733 6.36 10.2267 6.84667 10.5 7.18L11.92 8.88C11.98 8.95333 11.98 9.05333 11.92 9.12667L10.5 10.8267Z"
        fill={globalColors.primary}
      />
      <path
        d="M4.90667 12.0933C5.20667 12.0933 5.48 11.92 5.60667 11.6467C5.73333 11.3733 5.69333 11.0533 5.5 10.82L4.08 9.12C4.02 9.04667 4.02 8.94667 4.08 8.87333L5.5 7.17333C5.77333 6.84667 5.72667 6.36 5.4 6.08667C5.07333 5.81333 4.58667 5.86 4.31333 6.18667L2.38 8.50667C2.14 8.79333 2.14 9.21333 2.38 9.5L4.31333 11.82C4.46 12 4.68 12.1 4.90667 12.1V12.0933Z"
        fill={globalColors.primary}
      />
      <path
        d="M6.95333 11.7867C7.04 11.82 7.13333 11.8333 7.22667 11.84C7.54667 11.84 7.84 11.64 7.95333 11.34L9.5 7.21333C9.60667 6.95333 9.56 6.66 9.38 6.44C9.2 6.22 8.92 6.12 8.64667 6.16667C8.37333 6.21333 8.14 6.40667 8.04667 6.67333L6.5 10.8C6.35333 11.2 6.55333 11.6467 6.95333 11.7933V11.7867Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const PaymentIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 0H3C1.34 0 0 1.34 0 3V14C0 15.65 1.34 17 3 17H7C6.99 16.83 6.97 16.66 6.97 16.49C6.97 15.98 7.02 15.48 7.1 15H3C2.44 15 2 14.55 2 14V8C2 7.72 2.22 7.5 2.5 7.5H13.4C14.37 7.16 15.4 6.97 16.48 6.97C17.56 6.97 18.6 7.16 19.58 7.5H21.5C21.77 7.5 22 7.72 22 8V8.74C22.42 9.05 22.83 9.38 23.21 9.76C23.5 10.04 23.75 10.35 24 10.66V3C24 1.34 22.65 0 21 0ZM22 4C22 4.27 21.77 4.5 21.5 4.5H2.5C2.22 4.5 2 4.27 2 4V3C2 2.45 2.44 2 3 2H21C21.55 2 22 2.45 22 3V4Z"
        fill={globalColors.primary}
      />
      <path
        d="M5 11C4.44 11 4 11.45 4 12C4 12.55 4.44 13 5 13H7.64C7.89 12.37 8.2 11.76 8.58 11.21C8.41 11.08 8.22 11 8 11H5Z"
        fill={globalColors.primary}
      />
      <path
        d="M16.48 8.97C12.33 8.97 8.97 12.34 8.97 16.49C8.97 20.64 12.33 24 16.48 24C20.63 24 24 20.63 24 16.49C24 14.49 23.2 12.58 21.8 11.17C20.39 9.76 18.48 8.97 16.48 8.97ZM20.38 14.59L17.02 19.07C16.72 19.48 16.26 19.73 15.75 19.76H15.63C15.17 19.76 14.73 19.58 14.41 19.25L12.67 17.52C12.45 17.3 12.37 16.98 12.45 16.68C12.53 16.38 12.76 16.15 13.06 16.07C13.14 16.05 13.21 16.04 13.29 16.04C13.51 16.04 13.73 16.13 13.9 16.29L15.4 17.8C15.46 17.85 15.53 17.88 15.61 17.88H15.63C15.71 17.88 15.79 17.83 15.84 17.77L18.99 13.56C19.16 13.33 19.42 13.21 19.69 13.21C19.87 13.21 20.05 13.27 20.21 13.38C20.59 13.67 20.67 14.2 20.38 14.59Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const DateIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 10.5H6C5.45 10.5 5 10.95 5 11.5C5 12.05 5.45 12.5 6 12.5H7C7.55 12.5 8 12.05 8 11.5C8 10.95 7.55 10.5 7 10.5Z"
        fill={globalColors.primary}
      />
      <path
        d="M12 10.5H11C10.45 10.5 10 10.95 10 11.5C10 12.05 10.45 12.5 11 12.5H12C12.55 12.5 13 12.05 13 11.5C13 10.95 12.55 10.5 12 10.5Z"
        fill={globalColors.primary}
      />
      <path
        d="M17 10.5H16C15.45 10.5 15 10.95 15 11.5C15 12.05 15.45 12.5 16 12.5H17C17.55 12.5 18 12.05 18 11.5C18 10.95 17.55 10.5 17 10.5Z"
        fill={globalColors.primary}
      />
      <path
        d="M7 14.5H6C5.45 14.5 5 14.95 5 15.5C5 16.05 5.45 16.5 6 16.5H7C7.55 16.5 8 16.05 8 15.5C8 14.95 7.55 14.5 7 14.5Z"
        fill={globalColors.primary}
      />
      <path
        d="M12 14.5H11C10.45 14.5 10 14.95 10 15.5C10 16.05 10.45 16.5 11 16.5H12C12.55 16.5 13 16.05 13 15.5C13 14.95 12.55 14.5 12 14.5Z"
        fill={globalColors.primary}
      />
      <path
        d="M17 14.5H16C15.45 14.5 15 14.95 15 15.5C15 16.05 15.45 16.5 16 16.5H17C17.55 16.5 18 16.05 18 15.5C18 14.95 17.55 14.5 17 14.5Z"
        fill={globalColors.primary}
      />
      <path
        d="M7 18.5H6C5.45 18.5 5 18.95 5 19.5C5 20.05 5.45 20.5 6 20.5H7C7.55 20.5 8 20.05 8 19.5C8 18.95 7.55 18.5 7 18.5Z"
        fill={globalColors.primary}
      />
      <path
        d="M12 18.5H11C10.45 18.5 10 18.95 10 19.5C10 20.05 10.45 20.5 11 20.5H12C12.55 20.5 13 20.05 13 19.5C13 18.95 12.55 18.5 12 18.5Z"
        fill={globalColors.primary}
      />
      <path
        d="M17 18.5H16C15.45 18.5 15 18.95 15 19.5C15 20.05 15.45 20.5 16 20.5H17C17.55 20.5 18 20.05 18 19.5C18 18.95 17.55 18.5 17 18.5Z"
        fill={globalColors.primary}
      />
      <path
        d="M21 21.5C21 21.78 20.78 22 20.5 22H2.5C2.22 22 2 21.78 2 21.5V9.5C2 9.22 2.22 9 2.5 9H20.5C20.78 9 21 9.22 21 9.5V21.5ZM21 3H18.25C18.11 3 18 2.89 18 2.75V1C18 0.45 17.55 0 17 0C16.45 0 16 0.45 16 1V5.75C16 6.16 15.66 6.5 15.25 6.5C14.84 6.5 14.5 6.16 14.5 5.75V3.5C14.5 3.22 14.28 3 14 3H7.75C7.61 3 7.5 2.89 7.5 2.75V1C7.5 0.45 7.05 0 6.5 0C5.95 0 5.5 0.45 5.5 1V5.75C5.5 6.16 5.16 6.5 4.75 6.5C4.34 6.5 4 6.16 4 5.75V3.5C4 3.22 3.78 3 3.5 3H2C0.9 3 0 3.9 0 5V22C0 23.1 0.9 24 2 24H21C22.1 24 23 23.1 23 22V5C23 3.9 22.1 3 21 3Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const DateAndTimeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 16.5C2.22 16.5 2 16.28 2 16V7.5C2 7.22 2.22 7 2.5 7H16C16.28 7 16.5 7.22 16.5 7.5V9.57C17.16 9.48 17.84 9.48 18.5 9.57V3C18.5 2.45 18.05 2 17.5 2H15C14.86 2 14.75 1.89 14.75 1.75V0.75C14.75 0.34 14.41 0 14 0C13.59 0 13.25 0.34 13.25 0.75V4.5C13.25 4.91 12.91 5.25 12.5 5.25C12.09 5.25 11.75 4.91 11.75 4.5V2.5C11.75 2.22 11.53 2 11.25 2H7C6.86 2 6.75 1.89 6.75 1.75V0.75C6.75 0.34 6.41 0 6 0C5.59 0 5.25 0.34 5.25 0.75V4.5C5.25 4.91 4.91 5.25 4.5 5.25C4.09 5.25 3.75 4.91 3.75 4.5V2.5C3.75 2.22 3.53 2 3.25 2H1C0.45 2 0 2.45 0 3V16.5C0 17.6 0.9 18.5 2 18.5H9.57C9.48 17.84 9.48 17.16 9.57 16.5H2.5Z"
        fill={globalColors.primary}
      />
      <path
        d="M17.5 22C15.68 22 14.04 20.9 13.34 19.22C12.64 17.54 13.03 15.6 14.32 14.32C15.61 13.03 17.54 12.65 19.22 13.34C20.9 14.04 22 15.68 22 17.5C22 19.98 19.98 22 17.5 22ZM17.5 11C13.91 11 11 13.91 11 17.5C11 21.09 13.91 24 17.5 24C21.09 24 24 21.09 24 17.5C24 13.91 21.09 11 17.5 11Z"
        fill={globalColors.primary}
      />
      <path
        d="M19.5 16.75H18.25V15C18.25 14.59 17.91 14.25 17.5 14.25C17.09 14.25 16.75 14.59 16.75 15V17.5C16.75 17.91 17.09 18.25 17.5 18.25H19.5C19.91 18.25 20.25 17.91 20.25 17.5C20.25 17.09 19.91 16.75 19.5 16.75Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const AppointmentIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.57 16.5H2.5C2.22 16.5 2 16.28 2 16V7.5C2 7.22 2.22 7 2.5 7H16C16.28 7 16.5 7.22 16.5 7.5V9.57C17.16 9.48 17.84 9.48 18.5 9.57V3C18.5 2.45 18.05 2 17.5 2H15C14.86 2 14.75 1.89 14.75 1.75V0.75C14.75 0.34 14.41 0 14 0C13.59 0 13.25 0.34 13.25 0.75V4.5C13.25 4.91 12.91 5.25 12.5 5.25C12.09 5.25 11.75 4.91 11.75 4.5V2.5C11.75 2.22 11.53 2 11.25 2H7C6.86 2 6.75 1.89 6.75 1.75V0.75C6.75 0.34 6.41 0 6 0C5.59 0 5.25 0.34 5.25 0.75V4.5C5.25 4.91 4.91 5.25 4.5 5.25C4.09 5.25 3.75 4.91 3.75 4.5V2.5C3.75 2.22 3.53 2 3.25 2H1C0.45 2 0 2.45 0 3V16.5C0 17.6 0.9 18.5 2 18.5H9.57C9.48 17.84 9.48 17.16 9.57 16.5Z"
        fill={globalColors.primary}
      />
      <path
        d="M14.11 17.68C14.25 17.54 14.44 17.46 14.64 17.46C14.84 17.46 15.03 17.54 15.17 17.68L16.67 19.18L19.57 15.31C19.82 14.98 20.29 14.91 20.62 15.16C20.95 15.41 21.02 15.88 20.77 16.21L17.87 20.09C17.61 20.44 17.21 20.66 16.78 20.69C16.35 20.72 15.92 20.56 15.61 20.25L14.11 18.75C13.97 18.61 13.89 18.42 13.89 18.22C13.89 18.02 13.97 17.83 14.11 17.69V17.68ZM17.5 11C13.91 11 11 13.91 11 17.5C11 21.09 13.91 24 17.5 24C21.09 24 24 21.09 24 17.5C24 13.91 21.09 11 17.5 11Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const LinkedInIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5714 2C21.3304 2 22 2.66964 22 3.47321V20.5714C22 21.375 21.3304 22 20.5714 22H3.38393C2.625 22 2 21.375 2 20.5714V3.47321C2 2.66964 2.625 2 3.38393 2H20.5714ZM8.02679 19.1429V9.63393H5.08036V19.1429H8.02679ZM6.55357 8.29464C7.49107 8.29464 8.25 7.53571 8.25 6.59821C8.25 5.66071 7.49107 4.85714 6.55357 4.85714C5.57143 4.85714 4.8125 5.66071 4.8125 6.59821C4.8125 7.53571 5.57143 8.29464 6.55357 8.29464ZM19.1429 19.1429V13.9196C19.1429 11.375 18.5625 9.36607 15.5714 9.36607C14.1429 9.36607 13.1607 10.1696 12.7589 10.9286H12.7143V9.63393H9.90179V19.1429H12.8482V14.4554C12.8482 13.2054 13.0714 12 14.6339 12C16.1518 12 16.1518 13.4286 16.1518 14.5V19.1429H19.1429Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

const TwitterIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 32 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.6875 6.5C28.6875 6.8125 28.6875 7.0625 28.6875 7.375C28.6875 16.0625 22.125 26 10.0625 26C6.3125 26 2.875 24.9375 0 23.0625C0.5 23.125 1 23.1875 1.5625 23.1875C4.625 23.1875 7.4375 22.125 9.6875 20.375C6.8125 20.3125 4.375 18.4375 3.5625 15.8125C4 15.875 4.375 15.9375 4.8125 15.9375C5.375 15.9375 6 15.8125 6.5 15.6875C3.5 15.0625 1.25 12.4375 1.25 9.25V9.1875C2.125 9.6875 3.1875 9.9375 4.25 10C2.4375 8.8125 1.3125 6.8125 1.3125 4.5625C1.3125 3.3125 1.625 2.1875 2.1875 1.25C5.4375 5.1875 10.3125 7.8125 15.75 8.125C15.625 7.625 15.5625 7.125 15.5625 6.625C15.5625 3 18.5 0.0625 22.125 0.0625C24 0.0625 25.6875 0.8125 26.9375 2.125C28.375 1.8125 29.8125 1.25 31.0625 0.5C30.5625 2.0625 29.5625 3.3125 28.1875 4.125C29.5 4 30.8125 3.625 31.9375 3.125C31.0625 4.4375 29.9375 5.5625 28.6875 6.5Z"
        fill={globalColors.primary} />
    </svg>

  )
}

const CalculativeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.666626 0.666748H15.3333V15.3334H0.666626V0.666748ZM1.99996 2.00008V14.0001H14V2.00008H1.99996ZM5.99996 3.33341V4.66675H7.33329V6.00008H5.99996V7.33341H4.66663V6.00008H3.33329V4.66675H4.66663V3.33341H5.99996ZM8.66663 4.66675H12.6666V6.00008H8.66663V4.66675ZM4.39063 8.78141L5.33329 9.72408L6.27596 8.78141L7.21863 9.72408L6.27596 10.6667L7.21929 11.6094L6.27596 12.5527L5.33329 11.6094L4.39063 12.5534L3.44663 11.6094L4.39063 10.6667L3.44796 9.72408L4.39063 8.78141ZM8.66663 9.00008H12.6666V10.3334H8.66663V9.00008ZM8.66663 11.0001H12.6666V12.3334H8.66663V11.0001Z"
        fill={globalColors.primary}
      />
    </svg>


  )
}

const GoogleIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 31 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={globalColors.primary}
        d="M30.5 16.375C30.5 25.25 24.4375 31.5 15.5 31.5C6.875 31.5 0 24.625 0 16C0 7.4375 6.875 0.5 15.5 0.5C19.625 0.5 23.1875 2.0625 25.875 4.5625L21.625 8.625C16.125 3.3125 5.875 7.3125 5.875 16C5.875 21.4375 10.1875 25.8125 15.5 25.8125C21.625 25.8125 23.9375 21.4375 24.25 19.125H15.5V13.8125H30.25C30.375 14.625 30.5 15.375 30.5 16.375Z"
      />
    </svg>
  );
};

const FacebookIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47 14 5.5 16 5.5H17.5V2.14C17.174 2.097 15.943 2 14.643 2C11.928 2 10 3.657 10 6.7V9.5H7V13.5H10V22H14V13.5Z"
        fill="black" />
    </svg>
  );
};


const OpenProjectIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.9 3.59695e-05H11.66C11.2538 -0.00195612 10.8511 0.0788157 10.4752 0.23772C10.0993 0.396624 9.75745 0.630534 9.46933 0.926036C9.1812 1.22154 8.95244 1.57282 8.79617 1.95974C8.6399 2.34666 8.55919 2.7616 8.55867 3.18077V7.03906H3.10133C2.69492 7.03706 2.29213 7.1179 1.91607 7.27694C1.54002 7.43597 1.1981 7.67006 0.909952 7.96579C0.621799 8.26151 0.393083 8.61303 0.236929 9.00019C0.0807754 9.38735 0.000258748 9.80251 0 10.2219L0 12.7814C0 14.5486 1.38867 16 3.10133 16H4.34133C6.05467 16 7.44267 14.5486 7.44267 12.7814V10.2225C7.44267 10.1792 7.44267 10.1139 7.43933 10.1139H5.582V12.7828C5.582 13.4886 5.02533 14.0801 4.34133 14.0801H3.10133C2.41667 14.0801 1.86067 13.4858 1.86067 12.7828V10.2219C1.86127 10.0549 1.89389 9.88968 1.95664 9.73578C2.0194 9.58187 2.11104 9.4423 2.22631 9.3251C2.34157 9.2079 2.47816 9.11538 2.62823 9.05289C2.77829 8.9904 2.93885 8.95916 3.10067 8.96098H12.8987C14.612 8.96098 16 7.50956 16 5.74241V3.18283C15.9997 2.7636 15.9193 2.34855 15.7632 1.96149C15.6071 1.57442 15.3785 1.22296 15.0905 0.927254C14.8025 0.63155 14.4608 0.397427 14.0848 0.238313C13.7089 0.0791988 13.3063 -0.00177504 12.9 3.59695e-05ZM14.1407 5.74035C14.1407 6.44611 13.584 7.03768 12.9 7.03768H10.4193V3.18283C10.4199 3.01586 10.4526 2.85066 10.5153 2.69676C10.5781 2.54285 10.6697 2.40328 10.785 2.28608C10.9002 2.16887 11.0368 2.07636 11.1869 2.01387C11.337 1.95138 11.4975 1.92014 11.6593 1.92196H12.8993C13.0613 1.91996 13.222 1.95106 13.3722 2.01347C13.5224 2.07588 13.6592 2.16836 13.7746 2.28558C13.89 2.4028 13.9817 2.54244 14.0446 2.69644C14.1074 2.85043 14.1401 3.01574 14.1407 3.18283V5.74035ZM8.55867 12.4169V12.4375C8.55867 12.9507 8.978 13.362 9.48933 13.362C10.0007 13.362 10.4193 12.9534 10.4193 12.4402V10.1125H8.55867V12.4169Z"
        fill={globalColors.primary}
      />
    </svg>


  );
};

const TiktokIcon = () => {
  return (
    <svg width="16"
      height="18"
      viewBox="0 0 30 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30 13.125C27.1875 13.1875 24.5625 12.3125 22.3125 10.6875V21.875C22.3125 29.6875 13.8125 34.5625 7.0625 30.6875C0.3125 26.75 0.3125 17 7.0625 13.0625C9 11.9375 11.3125 11.5 13.5625 11.8125V17.4375C10.125 16.3125 6.8125 19.375 7.5625 22.875C8.375 26.375 12.625 27.75 15.3125 25.3125C16.25 24.4375 16.8125 23.1875 16.8125 21.875V0H22.3125C22.3125 0.5 22.3125 0.9375 22.4375 1.4375C22.8125 3.5 24 5.3125 25.8125 6.4375C27 7.25 28.5 7.6875 30 7.6875V13.125Z"
        fill="black"
      />
    </svg>
  );
};

const ScannerIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 11H21M3 11V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V11M3 11V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V11M7 7H7.01M7 15H7.01M17 7H17.01M17 15H17.01"
        stroke={globalColors.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const CameraIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z"
        stroke={globalColors.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z"
        stroke={globalColors.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

const ContactInfoIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 2.66669H2.66667C1.93333 2.66669 1.33333 3.26669 1.33333 4.00002V12C1.33333 12.7334 1.93333 13.3334 2.66667 13.3334H13.3333C14.0667 13.3334 14.6667 12.7334 14.6667 12V4.00002C14.6667 3.26669 14.0667 2.66669 13.3333 2.66669ZM13.3333 12H2.66667V4.00002H13.3333V12Z"
        fill={globalColors.primary}
      />
      <path
        d="M8 5.33331H12V6.66665H8V5.33331Z"
        fill={globalColors.primary}
      />
      <path
        d="M8 8H12V9.33333H8V8Z"
        fill={globalColors.primary}
      />
      <path
        d="M4 5.33331H6.66667V8H4V5.33331Z"
        fill={globalColors.primary}
      />
    </svg>
  );
};

export {
  AppointmentIcon,
  DateIcon,
  DateAndTimeIcon,
  DomainIcon,
  DropDownIcon,
  EmailIcon,
  HtmlIcon,
  InputIcon,
  LinkedInIcon,
  MultiInputIcon,
  MultiSelectIcon,
  NameAndSurnameIcon,
  AddressIcon,
  PaymentIcon,
  PhoneIcon,
  SingleSelectIcon,
  GoogleIcon,
  TwitterIcon,
  FacebookIcon,
  OpenProjectIcon,
  TiktokIcon,
  CalculativeIcon,
  RichTextIcon,
  GeolocationIcon,
  ScannerIcon,
  CameraIcon,
  ContactInfoIcon
};
